import { TransparentDeleteIcon } from 'assets/icons';
import ArrowIconThick from 'assets/images/arrows/arrowIconThick.svg?react';
import cn from 'classnames';
import { GamesState } from 'features/eventPreMatch/interface/sportPrematch';
import { motion } from 'framer-motion';
import { t } from 'i18next';
import './styles.scss';

interface BetBuilderBasketHeaderProps {
	totalOdds: number;
	selectedOddsArray: GamesState[];
	handleClick: () => void;
	isShowSelectedBets: boolean;
	clickOnCross: () => void;
	isMoreThenOneBetbuilderEvent: boolean;
}

const BetBuilderBasketHeader = ({
	totalOdds,
	selectedOddsArray,
	handleClick,
	isShowSelectedBets,
	clickOnCross,
	isMoreThenOneBetbuilderEvent,
}: BetBuilderBasketHeaderProps) => {
	return (
		<div className="BetbuilderOverview__wrapper">
			<div className="BetbuilderOverview__header">
				<div className="BetbuilderOverview__oddsInfo" aria-controls="fade-menu" onClick={handleClick}>
					{isMoreThenOneBetbuilderEvent && (
						<ArrowIconThick
							className={cn('BetbuilderOverview__dropdown__icon', {
								'BetbuilderOverview__dropdown__icon--rotated': isShowSelectedBets,
							})}
						/>
					)}
					<motion.div
						className="BetbuilderOverview__title"
						initial={{ x: -100, opacity: 0 }}
						animate={{ x: 0, opacity: 1 }}
						transition={{ duration: 0.5 }}
					>
						{t('betBuilder')} ({selectedOddsArray.length})
					</motion.div>
				</div>
				<div className="BetbuilderOverview__odds">
					{isMoreThenOneBetbuilderEvent && (
						<>
							<motion.div initial={{ opacity: 0 }} animate={{ opacity: 1 }} transition={{ duration: 0.5 }}>
								{totalOdds < 0 ? Number(0).toFixed(2) : totalOdds.toFixed(2)}
							</motion.div>

							{isShowSelectedBets && (
								<motion.div
									initial={{ opacity: 0 }}
									animate={{ opacity: 1 }}
									transition={{ duration: 0.5 }}
									className="BetbuilderOverview__deleteAll"
									data-cy="betbuilder-delete"
									onClick={clickOnCross}
								>
									<TransparentDeleteIcon />
								</motion.div>
							)}
						</>
					)}
				</div>
			</div>
		</div>
	);
};

export default BetBuilderBasketHeader;
